import { render, staticRenderFns } from "./ButtonRound.vue?vue&type=template&id=3c19ecaf&scoped=true"
import script from "./ButtonRound.vue?vue&type=script&lang=ts"
export * from "./ButtonRound.vue?vue&type=script&lang=ts"
import style0 from "./ButtonRound.vue?vue&type=style&index=0&id=3c19ecaf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19ecaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c19ecaf')) {
      api.createRecord('3c19ecaf', component.options)
    } else {
      api.reload('3c19ecaf', component.options)
    }
    module.hot.accept("./ButtonRound.vue?vue&type=template&id=3c19ecaf&scoped=true", function () {
      api.rerender('3c19ecaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ButtonRound.vue"
export default component.exports